import PaymentInfo from 'components/HappeningNonContent/ServiceBooking/ReviewAndPay/PaymentInfo/PaymentInfo';

export default PaymentInfo;
